import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import React from "react";
import { useScaffold } from "../../../scaffold";

export type ContextCheckEmailProps = {
  email: string;
  title?: string;
  subtitle?: string;
  resendButtonText?: string;
  changeEmailText?: string;
  linkExpirationMinutes?: number;
  onResendEmail?: () => void;
  onChangeEmail?: () => void;
  isLoading?: boolean;
  error?: string;
};

export const ContextCheckEmail: React.FC<ContextCheckEmailProps> = ({
  email,
  title = "Use the link we just emailed you to sign in",
  subtitle,
  resendButtonText = "Resend email",
  changeEmailText = "Use a different email",
  linkExpirationMinutes = 60,
  onResendEmail,
  onChangeEmail,
  isLoading = false,
  error,
}) => {
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;
  const ErrorMessage = scaffold.system.errorMessage;
  const Field = scaffold.system.field;

  const defaultSubtitle = `We emailed ${email} a login link to keep your account secure without a password. The link will expire in ${linkExpirationMinutes} minutes.`;

  return (
    <PageBody
      footer={
        <ButtonFooter>
          {error && (
            <Field>
              <ErrorMessage>{error}</ErrorMessage>
            </Field>
          )}
          {onResendEmail && (
            <Button
              size="lg"
              className="w-full"
              onClick={onResendEmail}
              disabled={isLoading}
            >
              {resendButtonText}
            </Button>
          )}
          {onChangeEmail && (
            <Button
              size="lg"
              buttonType="clear"
              className="w-full"
              onClick={onChangeEmail}
              disabled={isLoading}
            >
              {changeEmailText}
            </Button>
          )}
        </ButtonFooter>
      }
    >
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 gap-4 flex flex-col text-left">
        <div className="flex flex-col gap-2">
          <Title>{title}</Title>
          <Subtitle>{subtitle || defaultSubtitle}</Subtitle>
        </div>
      </div>
    </PageBody>
  );
};
